import { cssVar } from '@chakra-ui/react';

const $size = cssVar('stepper-indicator-size');

const customComponents = {
  Progress: {
    variants: {
      default: {
        filledTrack: {
          bg: 'background-page-02',
        },
      },
      warning: {
        filledTrack: {
          bg: 'alert-warning-default',
        },
      },
      error: {
        filledTrack: {
          bg: 'alert-error-default',
        },
      },
      success: {
        filledTrack: {
          bg: 'alert-success-default',
        },
      },
    },
  },
  Stepper: {
    baseStyle: {
      indicator: {
        '&[data-status=active]': {
          bg: 'primary-default',
          borderWidth: '1px',
          borderColor: 'primary-default',
          color: 'text-light',
        },
        '&[data-status=complete]': {
          bg: 'background-page',
          borderWidth: '1px',
          borderColor: 'primary-default',
          color: 'primary-default',
        },
        '&[data-status=incomplete]': {
          borderWidth: '1px',
          borderColor: 'cream',
        },
      },
      separator: {
        '&[data-status=incomplete]': {
          borderColor: 'background-static',
        },
        '&[data-status=active]': {
          borderColor: 'background-page-02',
        },
        '&[data-status=complete]': {
          bg: 'background-page-02',
        },
      },
      icon: {
        '&[data-status=complete]': {
          color: 'text-light',
        },
        '&[data-status=active]': {
          color: 'background-page-02',
        },
        '&[data-status=incomplete]': {
          color: 'background-static',
        },
      },
      number: {
        '&[data-status=complete]': {
          color: 'primary-default',
        },
        '&[data-status=active]': {
          color: 'text-light',
        },
        '&[data-status=incomplete]': {
          color: 'cream',
        },
      },
    },
    sizes: {
      s: {
        stepper: {
          [$size.variable]: '1.125rem',
        },
      },
    },
  },
  Radio: {
    baseStyle: {
      control: {
        _checked: {
          borderColor: 'secondary-default',
          background: 'secondary-default',
          _focus: {
            borderColor: 'secondary-default',
            bg: 'secondary-default',
          },
        },
      },
    },
  },
  Checkbox: {
    baseStyle: {
      control: {
        _checked: {
          borderColor: 'secondary-default',
          background: 'secondary-default',
          _focus: {
            borderColor: 'secondary-default',
            bg: 'secondary-default',
          },
        },
      },
    },
  },
};

export default customComponents;
